// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_1fuTdls0ZhFJNzURz1v8b6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/submissionButton/styles.css
// module id = 1353
// module chunks = 0